import { Navigate, Outlet, useLocation } from "react-router-dom";
import { pageRoutes } from "./page.routes";
import { tokenId } from "../Environments/environment";
import { Message, Storage } from "../Utility/Services";
import { useEffect, useState } from "react";
import Fallback from "./Fallback";

const PrivateRoutes = () => {

    const [isAuthorized, setIsAuthorized] = useState(null);
    let location = useLocation()

    useEffect(() => {
        let token = Storage.get("liqchat-panel-token");

        const verdict = () => {
            if (!token) {
                Message.error("Please login in order to get access.");
                return false;
            }

            if (token.split('.').length === 3) {
                window.scrollTo(0, 0)
                return true
            }

            Message.error("Invalid token. Please log in again to continue.");
            Storage.remove("liqchat-panel-token");
            return false;
        };

        setIsAuthorized(verdict());
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    if (isAuthorized === null) return <Fallback />

    return isAuthorized ? <Outlet /> : <Navigate to={'/'} />

};

export default PrivateRoutes